<script setup>
import axios  from "axios";
//import moment  from "moment";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-card
        class="mx-1 my-1"
        flat
        outlined
    >
        <v-card-title
            class="px-2 py-1"
        >
            <h2 class="ranking_head">タグランキング</h2>
        </v-card-title>
    <v-container fluid fill-height v-if="loading" style="height: 300px;">
      <v-layout justify-center align-center>
        <v-progress-circular :indeterminate="true" size="30" color="accent" />
      </v-layout>
    </v-container>

        <v-list>
  <v-list-item-group active-class="pink--text" v-model="selectedItem">
    <template v-for="(item, index) in ranking" >
      <v-list-item class="d-flex justify-center my-0 mx-0 px-0 py-0" :key="index">
        <template v-slot:default="{ active }">
            <div class="rank_key" @click="search(item.tag,active)">{{ item.tag }}</div>
        </template>
      </v-list-item>
      <v-divider
          v-if="index < ranking.length - 1"
          :key="`${index}-divider`"
      ></v-divider>
    </template>
  </v-list-item-group>
        </v-list>
    </v-card>
</template>
<script>
export default {
    props : ["therm","kind",],
    data : function(){
        return {
            activecontrol : true,
            ranking : [],
            loading : true,
            selectedItem : null,
            timeout : 0,
        };
    },
    computed: {
        _allquery() {
              return [this.therm, this.kind,];
        }
    },
    watch : {
        _allquery() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.disp();
            }, 500);
        },
    },
    methods : {
        search : function(data,active){
            if(!active)
                this.$emit('keysearch',{keyword:data});
			else
                this.$emit('keysearch',{keyword:""});
        },
        reset  : function(){
            this.selectedItem = null;
        },
        disp   : async function(){
            this.loading = true;
            this.selectedItem = null;
            this.ranking = [];
            var params = new URLSearchParams();
            if(this.therm!=null && this.therm != "")
                params.append("category",this.therm);
            if(this.kind!=null && this.kind != "")
                params.append("kind",this.kind);
            await axios.post("/api/release/get_reltrendtag",params)
            .then(response => {
                this.loading=false;
                this.ranking = response.data;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },

    created : async function(){
        this.disp();
    },
}
</script>
<style>
.ranking_head {
    display: block;
    padding: 5px;
    border-bottom: solid 1px;
    border-left: solid 5px #E03532;
    margin: 10px 0 0 0;
    width : 100%;
}
.rank_key{
    font-size    : 1.5rem;
    display : flex;
    width   : 100%;
    height  :30px;
    justify-content: center; /*左右中央揃え*/
    align-items: center;     /*上下中央揃え*/
}

</style>
